import {bool, oneOf, string, type SchemaToProps} from '../../runtime';
import {
    CONTROL_SIZES,
    CONTROL_VARIANTS,
    COMPONENT_RADII,
    ICON_VARIANTS,
    type ComponentRadius,
    type ControlSize,
    type ControlVariant,
    type IconVariant,
} from '../common';

const INPUT_SIZES = CONTROL_SIZES;
const INPUT_VARIANTS = CONTROL_VARIANTS;
const INPUT_RADII = COMPONENT_RADII;
const INPUT_ICON_VARIANTS = ICON_VARIANTS;

type InputSize = ControlSize;
type InputVariant = ControlVariant;
type InputRadius = ComponentRadius;
type InputIconVariant = IconVariant;

const inputSchema = {
    type: string.default('text'),
    name: string,
    value: string,
    placeholder: string,
    size: oneOf(INPUT_SIZES, 'lg' as InputSize),
    variant: oneOf(INPUT_VARIANTS, 'outline' as InputVariant),
    radius: oneOf(INPUT_RADII, 'md' as InputRadius),
    disabled: bool,
    readonly: bool,
    required: bool,
    invalid: bool,
    icon: string,
    iconTrailing: string,
    iconVariant: oneOf(INPUT_ICON_VARIANTS, 'outline' as InputIconVariant),
    clearable: bool,
    copyable: bool,
    kbd: string,
    prefix: string,
    suffix: string,
    rootClass: string,
    controlClass: string,
    class: string,
};

const inputGroupSchema = {
    size: oneOf(INPUT_SIZES, 'lg' as InputSize),
    variant: oneOf(INPUT_VARIANTS, 'outline' as InputVariant),
    radius: oneOf(INPUT_RADII, 'md' as InputRadius),
    label: string,
    description: string,
    descriptionTrailing: string,
    error: string,
    errors: string,
    badge: string,
    fieldClass: string,
    class: string,
};

const inputAffixSchema = {
    class: string,
};

type InputProps = SchemaToProps<typeof inputSchema>;

export {INPUT_ICON_VARIANTS, INPUT_RADII, INPUT_SIZES, INPUT_VARIANTS, inputAffixSchema, inputGroupSchema, inputSchema};
export type {InputIconVariant, InputProps, InputRadius, InputSize, InputVariant};
